/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Image_Export_Summary_TitleInputs */

const en_image_export_summary_title = /** @type {(inputs: Image_Export_Summary_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export Summary`)
};

const fr_image_export_summary_title = /** @type {(inputs: Image_Export_Summary_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resume de l'exportation`)
};

const de_image_export_summary_title = /** @type {(inputs: Image_Export_Summary_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportübersicht`)
};

const it_image_export_summary_title = /** @type {(inputs: Image_Export_Summary_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Riepilogo esportazione`)
};

const ru_image_export_summary_title = /** @type {(inputs: Image_Export_Summary_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сводка по экспорту`)
};

const es_image_export_summary_title = /** @type {(inputs: Image_Export_Summary_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resumen de exportación`)
};

const zh_cn2_image_export_summary_title = /** @type {(inputs: Image_Export_Summary_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`导出摘要`)
};

const ja_image_export_summary_title = /** @type {(inputs: Image_Export_Summary_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`エクスポートの概要`)
};

const hi_image_export_summary_title = /** @type {(inputs: Image_Export_Summary_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`निर्यात सारांश`)
};

const pt_pt2_image_export_summary_title = /** @type {(inputs: Image_Export_Summary_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resumo da Exportação`)
};

/**
* | output |
* | --- |
* | "Export Summary" |
*
* @param {Image_Export_Summary_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const image_export_summary_title = /** @type {((inputs?: Image_Export_Summary_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Export_Summary_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_image_export_summary_title(inputs)
	if (locale === "de") return de_image_export_summary_title(inputs)
	if (locale === "it") return it_image_export_summary_title(inputs)
	if (locale === "ru") return ru_image_export_summary_title(inputs)
	if (locale === "es") return es_image_export_summary_title(inputs)
	if (locale === "zh-CN") return zh_cn2_image_export_summary_title(inputs)
	if (locale === "ja") return ja_image_export_summary_title(inputs)
	if (locale === "hi") return hi_image_export_summary_title(inputs)
	if (locale === "pt-PT") return pt_pt2_image_export_summary_title(inputs)
	return en_image_export_summary_title(inputs)
});